class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.clearButton = this.querySelector('#CartDrawer-Clear');
    this.cartDrawerItems = this.querySelector('cart-drawer-items');

    if(this.clearButton) this.clearButton.addEventListener('click', () => {
      this.cartDrawerItems.clearCart()
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      if (typeof refreshCartDrawerSubtotalIfNeeded === 'function') {
        refreshCartDrawerSubtotalIfNeeded('cart-drawer:open');
      } else if (typeof refreshStrikethrough === 'function') {
        refreshStrikethrough();
      }
      if (typeof scheduleStrikethroughCascade === 'function') {
        scheduleStrikethroughCascade('cart-drawer:open', [300, 800, 1500]);
      }
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {

    console.log('cart-drawer.js renderContents ----------------------------------------------------------------')

    console.log('PARSED STATE: ', parsedState.sections)

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      const nextHtml = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (window.cartSubtotalDebug !== false) {
        const hasCompare =
          typeof nextHtml === 'string' &&
          (nextHtml.includes('cart-subtotal--compare') ||
            nextHtml.includes('cart-subtotal__compare') ||
            nextHtml.includes('cart-subtotal__original'));
        console.log('[cart-subtotal-debug] cart-drawer.renderContents writing', {
          selector: section.selector || section.id,
          incomingHasCompare: hasCompare,
          snippet: String(nextHtml || '').match(/totals__total-value[\s\S]{0,350}/)?.[0] || '(no totals__total-value match)',
        });
      }

      sectionElement.innerHTML = nextHtml;
      if (typeof logCartDomReplace === 'function') {
        logCartDomReplace('cart-drawer:renderContents', section.selector || section.id);
      }
      
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if(this.clearButton) this.clearButton.addEventListener('click', () => {
        this.cartDrawerItems.clearCart()
      });

      if (typeof scheduleRefreshStrikethrough === 'function') {
        scheduleRefreshStrikethrough('cart-drawer:renderContents');
      }

      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    var sections = [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-drawer',
        selector: '#CartDrawer-PromotionDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
    
    return sections;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    var sections = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];

    if(window.request.page_type == 'cart'){
      sections.push(
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        }
      );
    }

    var promotion_drawers = document.querySelectorAll('promotional-drawer');
    promotion_drawers.forEach(drawer => {
      sections.push({
        id: 'PromotionHolder',
        selector: '#PromotionDrawerFooter-' + drawer.dataset.promoId,
        section: 'cart-drawer',
      })
    });
    
    return sections;
  }

  clearCart(){
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_clear_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          if (typeof logCartDomReplace === 'function') {
            logCartDomReplace('cart-drawer:clearCart', section.selector || section.id);
          }
          console.log('RELOADED! ', elementToReplace)
        });

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((e) => {

        console.log('clear error: ', e)

        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);